
<div #sankey style="font-family: Poppins !important">
  <main>
    <article #fs fullscreen-able [class.is-active]="isActive" style="background-color: white;">
      <div style="background-color: #ffff;">
        <icon-chart 
            [headerConfig]="headerConfig" 
            [iconList]="iconList" 
            [data]="data" 
            [pageKey]="pageKey" 
            [heading]="heading" 
            [chartName]="'sankeyChart'"
            [config]="sankeyChartContainer" 
            [expand]="fs" 
            [fullscreen]="isFullscreen" 
            [item]="item"
            (layerControl)="layerControl($event)"
            (screenChanges)="fullscreenChanges($event)"
          ></icon-chart>
    </div>

      <div><loading *ngIf="isLoading"> </loading></div> 
      <!-- <div  #smallBarContainer></div> -->
      <div [style.display]="noData?'none':''"  id="SankeyChartDiv" class="sankey-wrapper" #sankeyChartContainer></div>
      <div style="height: 230px; width: auto; " *ngIf="noData">
       <span class="bg-text" >There is no data for this time period</span></div>
      
    </article>
  </main>
</div>